// components/Modal.jsx
import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  onConfirm,
  showCancelButton = true,
  confirmButtonColor = '#e83e8c',
  width = '520px',
  maxHeight = '80vh',
  closeOnBackdrop = false,
  footer, // ✅ Footer personalizado
}) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      document.body.style.overflowY = 'auto';
    }
    return () => {
      document.body.style.overflow = '';
      document.body.style.overflowY = 'auto';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      {closeOnBackdrop && (
        <div 
          className="absolute inset-0 bg-black/50"
          onClick={onClose}
        />
      )}
      {!closeOnBackdrop && (
        <div className="absolute inset-0 bg-black/50" />
      )}
      
      <div 
        ref={modalRef}
        className="relative bg-white rounded-2xl shadow-2xl w-full overflow-hidden border-2 border-[#e83e8c] animate-[swalRosaIn_0.4s_ease]"
        style={{ maxWidth: width, maxHeight: maxHeight }}
      >
        {/* Header */}
        <div className="sticky top-0 bg-white z-10 px-6 py-4 border-b border-gray-100 flex items-center justify-between">
          <h2 className="text-xl font-bold text-gray-800">
            {title}
          </h2>
          <button
            onClick={onClose}
            className="p-1 text-gray-400 hover:text-gray-600 rounded-lg transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 overflow-y-auto" style={{ maxHeight: `calc(${maxHeight} - 130px)` }}>
          {children}
        </div>

        {/* Footer */}
        <div className="sticky bottom-0 bg-white z-10 px-6 py-4 border-t border-gray-100">
          {footer ? (
            // ✅ Si hay footer personalizado, usarlo
            footer
          ) : (
            // ✅ Footer por defecto
            <div className="flex gap-3">
              {showCancelButton && (
                <button
                  onClick={onClose}
                  className="flex-1 px-4 py-2 border-2 border-gray-200 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium"
                >
                  {cancelText}
                </button>
              )}
              <button
                onClick={onConfirm}
                className="flex-1 px-4 py-2 text-white rounded-lg font-medium transition-all hover:shadow-lg"
                style={{ backgroundColor: confirmButtonColor }}
              >
                {confirmText}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;